(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('detailPanelLoadingScreen', detailPanelLoading);

    function detailPanelLoading() {
        return {
            restrict: 'E',
            template: '<div class="detail-panel-loading-screen" ng-if="vm.isRefreshing()"><div class="detail-panel-loading-screen-loader"></div></div>'
        };
    }
})();